import * as Preact from "preact"
import Index from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import Director from "@frog/source/models/juice/Director.js"
import manifest from "@frog/source/manifest.js"

import encounters from "@frog/source/data/encounters.js" // imported for loading encounters.

import "@frog/source/views/app/screens/SplashScreen.view.less"

import Logo from "@frog/source/images/ld47/logo.png"

export default class SplashScreen {
    render() {
        // <div class="Title">{manifest.name}</div>
        return (
            <div class="SplashScreen" onClick={this.onClick}>
                <div class="Background"/>
                <img class="Logo" src={Logo}/>
                <div class="Prompt">Click to play!</div>
            </div>
        )
    }
    onClick() {
        // Navigation.go("/game/encounters/level2")
        Director.add({
            "type": "load encounter",
            "encounter": encounters["level2"]
        })
    }
}
